import { render, staticRenderFns } from "./Factories.vue?vue&type=template&id=1c8e1f1a&"
import script from "./Factories.vue?vue&type=script&lang=js&"
export * from "./Factories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports